import styles from "./LinesRight.module.css"

export const LinesRightSvg = () => {
    return (
        <div className={styles.div}>
        </div>
    )
}

